import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { diffDate } from 'utilities/common';
import { formatDate } from 'utilities/common';

export const InformationLatest = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['{ Suspense }.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section className="pt-2" id="shipment-latest">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Action
        </div>
      )}

      <div className="row mb-4">
        <div className="col-12">
          {StateLoading ? (
            dummy?.map((d, i) => (
              <ListHorizontal
                key={i}
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            ))
          ) : (
            <>
              {data?.shipment?.status !== 'new' && (
                <ListHorizontal title="TPM" content={`${data?.tpm_manifest} Kali`} />
              )}

              {(data?.shipment?.status === 'new' || data?.shipment?.status === 'console') && (
                <ListHorizontal
                  title="Barang DiHub"
                  content={`${formatDate(data?.hub_signin_at)} (${diffDate(data?.hub_signin_at, new Date())} Hari) `} />
              )}

              {data?.current_hub && (
                <ListHorizontal
                  title="Current Hub"
                  content={
                    <span className={`badge bg-primary-lt ms-auto`}>
                      {data?.current_hub?.name}
                    </span>
                  }
                />
              )}
              {data?.pod_accepted_by && (
                <ListHorizontal
                  title="Surat Jalan"
                  content={
                    <span className='fs-8'>{`Diterima Oleh ${data?.pod_accepted_by}`}</span>
                  }
                />
              )}
              {data?.shipment?.vendor && (
                <ListHorizontal
                  title="Vendor"
                  content={
                    <span className='fs-8'>{data?.shipment?.vendor?.name}</span>
                  }
                />
              )}
              {data?.shipment?.driver && (
                <ListHorizontal
                  title="Driver/Kurir"
                  content={
                    <span className='fs-8'>{`${data?.shipment?.driver?.name} (${data?.shipment?.driver?.phone})`}</span>
                  }
                />
              )}
              {data?.cancelled_reason && (
                <ListHorizontal
                  title="Alasan Batal"
                  content={
                    <span className='fs-8'>{data?.cancelled_reason}</span>
                  }
                />
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};
